export const INITIAL_RECONNECT_DELAY = 1000; // 1 second
export const MAX_RECONNECT_DELAY = 30000; // 30 seconds
export const MAX_STORED_REQUESTS = 1000; // Maximum number of stored requests
